<ion-item-sliding #sliding>
  <ion-item  [class.deleteAnimation]="ticket?.animation == 1" [class.addAnimation]="ticket?.animation == 2" [class.ion-activatable]="isMobile" (click)="clicked($event)" [class.mobile]="isMobile" [class.active]="(general.activeTicket |async).ticket == ticket && !isMobile" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">
    <div slot="start" class="hover-bttn more" (click)="openTicketMenu($event)">
      <ion-icon name="fa-ellipsis-vertical"></ion-icon>
    </div>
    <div id="lastupdate">
      {{ticket?.lastUpdate | date : "dd.MM.yyyy"}}
    </div>
    <!-- <ion-avatar slot="start" [ngStyle]="{background: ticket?.state| TicketStateColor : ticket?.isClosed : null : pinned ? '0.5' : null}">
    <ion-icon *ngIf="pinned" name="fa-pin" style="transform: rotate(45deg);"></ion-icon>
    <ion-icon *ngIf="!pinned" name="fa-ticket"></ion-icon>
  </ion-avatar> -->
  <ion-label style="margin-right: 0;">
    <!-- <div style="color: var(--red); font-size: 12px; opacity: 0.7;">Offen</div> -->
    <h3>@if (showIsObserver) {
      <ion-icon name="{{ticket?.isObserver ? 'fa-eye' : 'fa-hammer'}}"></ion-icon>
    } {{ticket.description}}</h3>
    <p>TicketNr.: {{ticket.number}}</p>
    <p>Kunde: {{ticket.addressSearchText}}</p>
    <div class="meta">
      @if (ticket?.priority) {
        <div class="priority" [ngStyle]="{'color': '#fff', 'background': priority?.rgba}" [title]="'Priorität: ' + priority?.text">
          <ion-icon [name]="priority?.icon"></ion-icon>
        </div>
      }
      @if (ticket?.state) {
        <div class="priority" [ngStyle]="{background: ticket?.state| TicketStateColor : ticket?.isClosed : null : '0.3', color: ticket?.state| TicketStateColor : ticket?.isClosed : null}">
          {{ticket?.state | TicketStateDescription}}
        </div>
      }
      @if(general.serverVersionGreaterThan("1.11.3")){
        <div class="priority chip-art">
          {{(ticket?.art | TicketArt)?.description || "Ticketart unbekannt"}}
        </div>
      }
      @if (activeTimes.length > 0) {
        <div class="tb-times" (click)="showAllTimes($event)" [hoverTitle]="{text: 'Zeit öffnen', position: 'top'}">
          @if (activeTimes.length == 1) {
            <div>
              <ion-icon name="fa-timer"></ion-icon>
              <span>{{timeSrv.getDifference(activeTimes[0].time.timeFrom, now, 'mm:ss')}} Std.</span>
            </div>
          }
          @if (activeTimes.length > 1) {
            <span>{{activeTimes.length}} Zeiten</span>
          }
        </div>
      }
    </div>
  </ion-label>
  <div slot="end"  style="margin-left: 0; min-width: 60px;">
    <div class="ss-time" [class.min-width-time]="ticket?.timeFrom">
      @if (!isMyTime) {
        <div #start class="bttn-ss-time" (click)="startTimeByTicket($event)"  [hoverTitle]="{text: 'Zeit starten', position: 'left'}">
          <svg [class.none]="startLoading" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="play" class="svg-inline--fa fa-play fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="var(--text)" d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path></svg>
          @if (startLoading) {
            <svg id="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"/></svg>
          }
        </div>
      }
      <!-- <div *ngIf="activeTimes.length == 1" class="timer">{{timeSrv.getDifference(activeTimes[0].time.timeFrom, now, 'mm:ss')}} Std.</div> -->


      <!-- <div class="tb-times" (click)="showAllTimes($event)" *ngIf="activeTimes.length > 0">
      {{activeTimes.length}}
      <span *ngIf="activeTimes.length == 1">Zeit</span>
      <span *ngIf="activeTimes.length > 1">Zeiten</span>
    </div> -->
  </div>
</div>
</ion-item>

@if (isMobile) {
  <ion-item-options side="end" mode="md">
    <ion-item-option style="--background: var(--red)" (click)="deleteTicket()">
      <ion-icon slot="icon-only" name="fa-trash"></ion-icon>
    </ion-item-option>
    <ion-item-option style="--background: var(--blue)" (click)="pinTicket()">
      @if (!pinned) {
        <ion-icon slot="icon-only" name="fa-pin" style="transform: rotate(45deg);"></ion-icon>
      }
      @if (pinned) {
        <ion-icon slot="icon-only" name="fa-unpin" style="transform: rotate(45deg);"></ion-icon>
      }
    </ion-item-option>
  </ion-item-options>
}

</ion-item-sliding>
